import client from '@/clients/customer/api-client';
import Qs from 'qs';
import { withCacheTTL } from '../common/with-cache-ttl';
import { env } from '@/constant/configs';

export const fetchFavorites = (filter: any, headers: any) =>
  client.get('/favorites', {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
    headers,
  });

export const fetchCachedFavorites: any = withCacheTTL(
  fetchFavorites,
  '/favorites'
);

export const addToFavorite = (type: string, id: number) =>
  client.post(`/favorites/${type}/${id}`);

export const removeFromFavorite = (type: string, id: number) =>
  client.delete(`/favorites/${type}/${id}`);

export const customerFavoritesPath = env.api_url + '/v1/customer/favorites';
